export default "__VITE_ASSET__BdPPVF26__"